import { Bar, BarSegment } from '@waves/bar';
import { Tooltip } from '@waves/tooltip';
import React, { ReactElement } from 'react';
import { StyleSheet } from 'react-native';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'waves-bar': {
        size?: 'sm' | 'md' | 'lg';
        type?: 'stacked' | 'layered';
        legend?: 'inline' | 'tooltip';
        'disable-motion'?: boolean;
        children?: React.ReactNode;
      };
    }
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'waves-bar-segment': {
        value: number | string;
        color?: string;
        label?: string;
        'label-value'?: string;
        key?: React.Key;
      };
    }
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'waves-tooltip': {
        children?: React.ReactNode;
      };
    }
  }
}

export interface KitBarSegment {
  value: number | string;
  color?: string;
  label?: string;
  labelValue?: string;
}

export interface KitBarProps {
  segments?: KitBarSegment[];
  size?: 'sm' | 'md' | 'lg';
  type?: 'stacked' | 'layered';
  legend?: 'inline' | 'tooltip';
  disableMotion?: boolean;
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (!window.customElements.get('waves-bar')) {
    window.customElements.define('waves-bar', Bar);
  }

  if (!window.customElements.get('waves-bar-segment')) {
    window.customElements.define('waves-bar-segment', BarSegment);
  }

  if (!window.customElements.get('waves-tooltip')) {
    window.customElements.define('waves-tooltip', Tooltip);
  }
}

export default function KitBar({
  segments = [],
  size,
  type,
  legend,
  disableMotion,
}: KitBarProps): ReactElement {
  return (
    <waves-bar
      size={size}
      type={type}
      legend={legend}
      disable-motion={disableMotion}
    >
      {segments.map((segment, index) => (
        <waves-bar-segment
          key={index}
          value={segment.value}
          color={segment.color}
          label={segment.label}
          label-value={segment.labelValue}
        />
      ))}
    </waves-bar>
  );
}

//******************************************************************************
// Styles
//******************************************************************************

const styles = StyleSheet.create({});
